<template>
  <!-- <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <circle cx="11.0003" cy="10.8333" r="3.61067" fill="#E4E7EC" />
  </svg> -->

  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 23 22"
    fill="none"
  >
    <rect
      x="0.451172"
      y="0.222656"
      width="21.664"
      height="21.664"
      rx="10.832"
      fill="#F9FAFB"
    />
    <circle cx="11.2835" cy="11.056" r="3.61067" fill="#E4E7EC" />
  </svg>
</template>

<script>
export default {
  name: "IconStepperInactive",
};
</script>

<style></style>
